import { Component, input } from '@angular/core';
import {
  AgrSummaryCardHorizontalModule,
  SummaryCardAction,
  SummaryCardHorizontalItem,
} from '@next/core-lib/components';

@Component({
  selector: 'app-flock-overview-week-registration-card',
  templateUrl: './flock-overview-week-registration-card.component.html',
  imports: [AgrSummaryCardHorizontalModule],
})
export class FlockOverviewWeekRegistrationCardComponent {
  readonly title = input<string>();
  readonly actions = input<SummaryCardAction[]>([]);
  readonly items = input<SummaryCardHorizontalItem[]>([]);
}
